import {
  FETCH_QUALIFICATIONS,
  FETCH_QUALIFICATIONS_SUCCESS,
  FETCH_QUALIFICATIONS_FAILURE,
  CREATE_QUALIFICATION_REQUEST,
  CREATE_QUALIFICATION_SUCCESS,
  CREATE_QUALIFICATION_FAILURE,
} from "./actionTypes";

const initialState = {
  qualifications: [],
  loading: false,
  error: null,
  success:false
};

const qualificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_QUALIFICATIONS:
      return { ...state, loading: true, success: false, error: null };

    case FETCH_QUALIFICATIONS_SUCCESS:
      return { ...state, loading: false, success: true, qualifications: action.payload.data };

    case FETCH_QUALIFICATIONS_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    case CREATE_QUALIFICATION_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case CREATE_QUALIFICATION_SUCCESS:
      return { ...state, loading: false, success: true, qualificationData: action.payload, error: null };

    case CREATE_QUALIFICATION_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    default:
      return state;
  }
};

export default qualificationReducer;
